import Vue from 'vue'
import Vuex from 'vuex'
import httpClient from '@/api/httpClient';
// import axios from "axios";

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    areas: [],
    isAreasLoading: false,
    isAreasLoaded: false,
    getAreasErrorMessage: '',
    area: null,
    isAreaLoading: false,
    isAreaLoaded: false,
    getAreaErrorMessage: '',
    isLanguagesLoading: false,
    isLanguagesLoaded: false,
    languages: [],
    getLanguagesErrorMessage: '',
    countries: [],
    isCountriesLoading: false,
    isCountriesLoaded: false,
    getCountriesErrorMessage: '',
    country: null,
    isCountryLoading: false,
    isCountrysLoaded: false,
    getCountryErrorMessage: '',
    currentArea: null,
    currentCountry: null,
    currentPageCode: null,
    currentLanguage : null,
  },
  mutations: {
    startGetAreas: function(state) {
      state.isAreasLoading = true;
      state.isAreasLoaded = false;
    },
    doneGetAreas: function(state, data, errorMessage) {
      state.areas = data;
      state.getAreasErrorMessage = errorMessage;
      state.isAreasLoading = false;
      state.isAreasLoaded = true;
      //Vue.$sessionStorage.set('areas', data);
    },
    startGetArea: function(state) {
      state.isAreaLoading = true;
      state.isAreaLoaded = false;
    },
    doneGetArea: function(state, data, errorMessage) {
      state.area = data;
      state.getAreaErrorMessage = errorMessage;
      state.isAreaLoading = false;
      state.isAreaLoaded = true;
      //Vue.$sessionStorage.set('areas', data);
    },
    startGetLanguages: function(state) {
      state.isLanguagesLoading = true;
      state.isLanguagesLoaded = false;
    },
    doneGetLanguages: function(state, data, errorMessage) {
      state.languages = data;
      state.getLanguagesErrorMessage = errorMessage;
      state.isLanguagesLoading = false;
      state.isLanguagesLoaded = true;
      //Vue.$sessionStorage.set('languages', data);
    },
    startGetCountries: function(state) {
      state.isCountriesLoading = true;
      state.isCountriesLoaded = false;
    },
    doneGetCountries: function(state, data, errorMessage) {
      state.countries = data;
      state.getCountriesErrorMessage = errorMessage;
      state.isCountriesLoading = false;
      state.isCountriesLoaded = true;
      //Vue.$sessionStorage.set('countries', data);
    },
    startGetCountryById: function(state) {
      state.isCountryLoading = true;
      state.isCountryLoaded = false;
    },
    doneGetCountryById: function(state, data, errorMessage) {
      state.country = data;
      state.getCountryErrorMessage = errorMessage;
      state.isCountryLoading = false;
      state.isCountryLoaded = true;
      //Vue.$sessionStorage.set('countries', data);
    },
    DoneSetCurrentArea: function(state, data) {
      state.area = data;
      Vue.$sessionStorage.set('currentArea', data);
    },
    DoneSetCurrentCountry: function(state, data) {
      state.currentCountry = data;
      Vue.$sessionStorage.set('currentCountry', data);
    },
    DoneSetCurrentPageCode: function(state, data) {
      state.currentPageCode = data;
      Vue.$sessionStorage.set('currentPageCode', data);
    },
    DoneSetCurrentLanguage: function(state, data) {
      state.currentLanguage = data;
      //Vue.$sessionStorage.set('currentLanguage', data);
    }
  },
  actions: {
    getAreas: function({commit}, params){
      commit('startGetAreas');
      return httpClient
        .get("/areas", params)
        .then(response => {
          console.log("[store] getAreas response", response);
          if (response.areas) {
            commit('doneGetAreas', response.areas, null)
          }
        })
        .catch(error => {
          console.log("error", error);
          commit('doneGetAreas', null, error.response)
        });
    },
    getAreaById: function({commit}, params){
      commit('startGetArea');
      return httpClient
        .get("/areas/"+ params.params.aid, params)
        .then(response => {
          console.log("[store] getAreaById response", response);
          if (response.area) {
            commit('doneGetArea', response.area, null)
          }
        })
        .catch(error => {
          console.log("error", error);
          commit('doneGetArea', null, error.response)
        });
    },
    getCountries: function({commit}, params){

      commit('startGetCountries');
      return httpClient
        .get("/countries", params)
        .then(response => {
          console.log("[store] getCountries response", response);
          if (response.countries) {
            commit('doneGetCountries', response.countries, null)
          }
        })
        .catch(error => {
          console.log("error", error);
          commit('doneGetCountries', null, error.response)
        });
    },
    getCountryById: function({commit}, params){

      commit('startGetCountryById');
      return httpClient
        .get("/countries/"+ params.params.cid, params)
        .then(response => {
          console.log("[store] getCountryById response", response);
          if (response.country) {
            commit('doneGetCountryById', response.country, null)
          }
        })
        .catch(error => {
          console.log("error", error);
          commit('doneGetCountryById', null, error.response)
        });
    },
    getLanguages: function({commit}){

      commit('startGetLanguages');
      return httpClient
        .get("/languages")
        .then(response => {
          console.log("[store] getLanguages response", response);
          if (response.languages) {
            commit('doneGetLanguages', response.languages, null)
          }
        })
        .catch(error => {
          console.log("error", error);
          commit('doneGetLanguages', null, error.response)
        });
    },
    SetCurrentArea: function({commit}, data) {
      commit('DoneSetCurrentArea', data);
    },
    SetCurrentCountry: function({commit}, data) {
      commit('DoneSetCurrentCountry', data.id);
    },
    SetCurrentPageCode: function({commit}, pageCode) {
      commit('DoneSetCurrentPageCode', pageCode);
    },
    setCurrentLanguage: function({commit}, data) {
      commit('DoneSetCurrentLanguage', data);
    }
  },
  modules: {
  }
})
